
  <div class="modal fade show expanded" tabindex="-1"  id="modal-head"
    aria-labelledby="business-partners-modalLabel" aria-hidden="true" [ngStyle]="{'display': 'block'}">

    <div class="modal-dialog modal-xl">
      <div class="modal-content">
    <app-loader *ngIf="UserProfileService.apiCallsInProgress.length > 0"></app-loader>
        <div class="modal-header float-end">
          <div class="d-flex w-100">
            <div class="me-2 id flex-fill">
                <h4 class="modal-title mb-0 item-id">
                  {{userProfile?.[UPGeneralFields.userId] ?  userProfile?.[UPGeneralFields.userId]+ ' - '+userProfile?.[UPGeneralFields.name] : 'Create User'}}</h4>
            </div>

            <div class="btns-header">
                <button
                    class="header-icon close p-0 m-0"
                    (click)="checkUnsavedDataBeforeClosing('header close button')"
                    aria-label="Close"
                >
                    <i
                        class="fas fa-times"
                        title="Close Popup"
                    ></i>
                </button>
            </div>
        </div>
      </div>




        <div class="modal-body page-body" id="modal-body">
          @if (reloadSection !== 'ALL') {
  <app-up-general
  [actions]="action"
  [userId]="$safeNavigationMigration(userProfile?.[UPGeneralFields.userId])"
  [userProfile]="userProfile"
  [reloadSection]="reloadSection === 'gen'"
  (isUserActiveOutput)="isUserActive = $event;"
  (genUserDataOutput)="genUserData = $event;"
  (profileModified)="onProfileModified($event);"
  ></app-up-general>

  

  <app-up-rims-service
  [actions]="action"
  [reloadSection]="reloadSection === 'service'"
  [userProfile]="userProfile"
  (profileModified)="onProfileModified($event)"
  (sendProfileDataToParent)="receiveProfileDataFromChild($event)"
  ></app-up-rims-service>

  <app-up-rims-sales
  [actions]="action"
  [reloadSection]="reloadSection === 'sales'"
  [userProfile]="userProfile"
  (profileModified)="onProfileModified($event)"
  (sendProfileDataToParent)="receiveProfileDataFromChild($event)"
  ></app-up-rims-sales>
  
}

        </div>

        <div class="modal-footer">
          <!-- {{UserProfileService.apiCallsInProgress}} -->
             @if (getPermission('unlockAccountButton')?.visible) {
               <button type="button" style="background-color: #A9A9A9;" (click)="unlockAccount()" [disabled]="!userId || !getPermission('unlockAccountButton')?.enable || lockAccountButtonText == 'Unlocked'" class="btn btn-sm">{{lockAccountButtonText}}</button>
             }
             @if (getPermission('resetAuthButton')?.visible) {
               <button type="button" style="color: whitesmoke;" (click)="resetAuth()" [disabled]="!userId || !getPermission('resetAuthButton')?.enable || isResetAuthDisabled" class="btn btn-sm btn-warning">Reset Authentication</button>
             }
            @if (getPermission('changePasswordButton')?.visible) {
              <button type="button" style="background-color: #808080;" (click)="setChangePasswordFlag()" [disabled]="!userId || !getPermission('changePasswordButton')?.enable || genUserData?.isSSO" class="btn btn-sm">Change Password On Login</button>
            }
            @if (getPermission('resetPersistenceButton')?.visible) {
            <button type="button" style="background-color: #007BFF;" (click)="resetProfilePersistence()" [disabled]="!userId || !getPermission('resetPersistenceButton')?.enable" class="btn btn-sm">Reset Persistence</button>
            }
            <button type="button" class="btn btn-sm btn-danger close-modal px-2" (click)="checkUnsavedDataBeforeClosing('close footer button')">Close</button>

          <div class="btn-group dropup" [ngClass]="{'disabled': !enableSaveButton || !getPermission('saveButton')?.enable}">
              <button type="button" class="btn btn-sm btn-success comment-action-item" style="width: 90px;"
                    (click)="saveButtonClick()">
                  Save
              </button>
              <button type="button" *ngIf="!isCreatingNewUser"
                  class="btn btn-sm btn-success comment-action-item dropdown-toggle dropdown-toggle-split"
                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              </button>
              <div class="dropdown-menu" *ngIf="!isCreatingNewUser">
                  <a class="dropdown-item" *ngIf="!isUserActive" (click)="saveButtonClick('Save & Activate')">{{
                      'Save & Activate' }}</a>
                  <a class="dropdown-item" *ngIf="isUserActive" (click)="saveButtonClick('Save & Deactivate')">{{
                      'Save & Deactivate' }}</a>
                  <a class="dropdown-item" (click)="saveButtonClick('Save & Close')">{{
                      'Save & Close' }}</a>
              </div>
          </div>


        </div>
      </div>
    </div>
  </div>
